// extracted by mini-css-extract-plugin
export default {"img":"styles_img__kh4ph","none":"styles_none__pdmfB","loader":"styles_loader__hoqUh"};